import React, { useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { AnalyticsContext } from '../../analytics/AnalyticsContext';
import useAnalytics from '../../hooks/useAnalytics';
import Img from "gatsby-image"

import './ScreenshotAccessBlock.scss';
import { KiteIcon, KiteLink } from '@kite/react-kite';

const ScreenshotAccessBlock = () => {
  const analytics = useAnalytics();
  const images = useStaticQuery(
    graphql`
      query ScreenshotAccessBlockImagesQuery {
        badgeAppleStore: file(
          relativePath: { eq: "ads/badge-apple-app-store.png" }
        ) {
          ...ImageFragment
        }
        badgeGooglePlayStore: file(
          relativePath: { eq: "ads/badge-google-play-copy.png" }
        ) {
          ...ImageFragment
        }
        accessScreenshot: file(relativePath: { eq: "access_image.png" }) {
          ...ImageFragment
        }
      }

      fragment ImageFragment on File {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    `
  );

  return (
    <div className="screenshot-access-block">
      <div className="screenshot-access-block__gradient" />
      <div className="screenshot-access-block__content">
        <div className="screenshot-access-block__image-wrapper">
          <Img
            className="screenshot-access-block__image"
            fluid={images.accessScreenshot.childImageSharp.fluid}
            alt="Screenshots of Spectrum Access app on mobile phone and tablet"
          />
        </div>
        <div className="screenshot-access-block__text">
          <img
            src="/images/spectrum-access-logo.png"
            alt="Spectrum Access Logo"
            className="screenshot-access-block__logo"
          />
          <p className="screenshot-access-block__subtitle">
            Seamless • Immersive • Accessible
          </p>
          <p className="screenshot-access-block__copy">
            Spectrum Access provides you with a free, open app that allows you
            to listen to audio description as you stream content.
          </p>
          <p className="screenshot-access-block__label">Available On</p>
          <div className="screenshot-access-block__buttons">
            <a
              href="https://apps.apple.com/us/app/spectrum-access-enabled-media/id1492182876"
              target="_blank"
              rel="noreferrer"
              className="button"
              aria-label="Download on the Apple App Store"
              onClick={() =>
                analytics.track('selectAction', {
                  currPageElemStdName: 'DownloadAppleAppStore',
                  msgCategory: 'navigation',
                  msgTriggeredBy: 'user',
                  opType: 'buttonClick',
                })
              }
            >
              <Img
                fluid={images.badgeAppleStore.childImageSharp.fluid}
                alt=""
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.spectrum.access"
              target="_blank"
              rel="noreferrer"
              className="button"
              aria-label="Download on the Google Play Store"
              onClick={() =>
                analytics.track('selectAction', {
                  currPageElemStdName: 'DownloadGoogleAppStore',
                  msgCategory: 'navigation',
                  msgTriggeredBy: 'user',
                  opType: 'buttonClick',
                })
              }
            >
              <Img
                fluid={images.badgeGooglePlayStore.childImageSharp.fluid}
                alt=""
              />
            </a>
          </div>
          <div className="screenshot-access-block__description-wrapper">
            <p className="screenshot-access-block__description-text">
              View all available audio description content on
            </p>
            <KiteLink
              className="screenshot-access-block__description-link"
              href="/access"
              type='standalone'
            >
              Spectrum Access
              <KiteIcon className='screenshot-access-block__link-icon' icon="ki-chevron-right" size='14px'/>
            </KiteLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotAccessBlock;
